export const CONTACT_INFO = {
  BACK: 'Previous step',
  NEXT: 'Next',
  VALIDATIONS: {
    ZIP: 'Please enter a valid zip/postal code',
    PHONE: 'Please enter a valid international number; must include country code',
  },
};
